var _path, _path2, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2Benefiticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3334 45.9867C19.3334 45.427 19.7915 44.9733 20.3566 44.9733H47.6435C48.2086 44.9733 48.6667 45.427 48.6667 45.9867C48.6667 46.5463 48.2086 47 47.6435 47H20.3566C19.7915 47 19.3334 46.5463 19.3334 45.9867Z",
    fill: "#7957FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9198 24.1872C21.721 25.3744 21.721 27.2851 21.721 31.1067V37.8622C21.721 40.4099 21.721 41.6837 22.5202 42.4752C23.3194 43.2667 24.6057 43.2667 27.1783 43.2667H40.8217C43.3944 43.2667 44.6807 43.2667 45.4799 42.4752C46.2791 41.6837 46.2791 40.4099 46.2791 37.8622V31.1067C46.2791 27.2851 46.2791 25.3744 45.0803 24.1872C43.8815 23 41.952 23 38.0931 23H29.907C26.0481 23 24.1186 23 22.9198 24.1872ZM28.8838 39.2133C28.8838 38.6537 29.3419 38.2 29.907 38.2H38.0931C38.6582 38.2 39.1163 38.6537 39.1163 39.2133C39.1163 39.773 38.6582 40.2267 38.0931 40.2267H29.907C29.3419 40.2267 28.8838 39.773 28.8838 39.2133Z",
    fill: "#7957FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 58,
    height: 58,
    rx: 15.5,
    stroke: "url(#paint0_linear_27_1846)",
    strokeOpacity: 0.3,
    strokeWidth: 11
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_1846",
    x1: 34.5,
    y1: 0,
    x2: 34.5,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Benefiticon);
export default __webpack_public_path__ + "static/media/2 benefit icon.c10f323862485c36a9758a80202497b6.svg";
export { ForwardRef as ReactComponent };